// Port of api/fuel/app/classes/controller/api/monty/groups/remove.php
import DB from 'offline/db'
import Util from 'offline/util'
import Constants from 'offline/constants'
import { currentUser, groupPayload, invalid, persist, recountGroupUsers, recountUserGroups, resolveGroup, touchGroup } from './shared'

export default function(params) {
	var sessionUser = currentUser(params)
	var group = resolveGroup(params)
	if (!sessionUser || !group) return invalid(Constants.API_ERROR_UNAUTHORISED)
	if (sessionUser.get_id() !== group.get_user_id()) return invalid(Constants.API_ERROR_UNAUTHORISED)
	if (group.get_type() !== Constants.GROUP_TYPE_STANDARD) return invalid(Constants.API_ERROR_UNAUTHORISED)

	var users = Array.isArray(params.users) ? params.users : []
	var filtered = []
	for (var i = 0; i < users.length; i++) {
		var userId = parseInt(users[i], 10) || 0
		if (userId && userId !== group.get_user_id()) filtered.push(userId)
	}

	if (!filtered.length) return invalid(Constants.API_ERROR_USER_NOTFOUND)

	DB.run('DELETE FROM link_group_user WHERE group_id = ? AND user_id IN (' + Util.in(filtered) + ')', [group.get_id()])
	touchGroup(group.get_id())
	recountGroupUsers(group.get_id())
	for (var j = 0; j < filtered.length; j++) recountUserGroups(filtered[j])

	return persist({
		group: groupPayload(group.get_id())
	})
}
